import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import ReactAudioPlayer from 'react-audio-player';
import ReactPlayer from 'react-player';

const QuestionContents = (props) => {
    const { t, i18n } = useTranslation();

    // Görselin boyutları için state
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (props.question['type'] === 'image' && props.question['url']) {
            // Görsel yüklendiğinde boyutlarını al
            const img = new Image();
            img.onload = () => {
                setImageDimensions({ width: img.width, height: img.height });
            };
            img.src = props.question['url'];
        }
    }, [props.question]);

    // Görselin en/boy oranına göre padding hesaplamak
    const getDynamicPadding = () => {
        const ratio = imageDimensions.width / imageDimensions.height;
        if (ratio > 1) {
            // Yatay (16:9 gibi)
            return { paddingTop: "10px", paddingBottom: "10px" };
        } else if (ratio < 1) {
            // Dikey (9:16 gibi)
            return { paddingLeft: "10px", paddingRight: "10px" };
        }
        return {}; // Kare resimler için padding yok
    };

    // Medya türü kontrolü yaparak boş kutuyu engelle
    const hasMediaContent = props.question['type'] === "sound" || props.question['type'] === "video" || props.question['type'] === "image" || props.question['type'] === "image_sound";
    if (!hasMediaContent) {
        return null; // Medya içeriği yoksa hiçbir şey render etme
    }
    return (

        <div style={{
            justifyContent: "center",
            alignItems: "center",
            display: hasMediaContent ? "flex" : "block",  // sadece medya varsa flex, yoksa block
            width: "100%",

            maxWidth: "500px",
            margin: "0 auto",
            overflow: "hidden",
            padding: "10px"
        }}>
            {props.question['type'] === "image_sound" ? (
                <div>
                    <div style={{
                        width: "100%",
                        height: "auto",
                        maxWidth: "500px",
                        maxHeight: "300px"
                    }}>
                        <ReactAudioPlayer
                            src={props.question['soundUrl']}
                            controls={true}
                            controlsList="nodownload"

                        />
                    </div>
                    <br />
                    <div style={{
                        width: "auto",
                        maxWidth: "auto",
                        height: "auto",
                        margin: "0 auto",
                        overflow: "hidden",
                        ...getDynamicPadding()  // Dinamik padding uygula   
                    }}>
                        <img
                            src={props.question['url']}
                            alt="Question Media"
                            style={{
                                width: "80%",
                                height: "100%",
                                maxHeight: "250px",
                                objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                            }}
                        />
                    </div>

                </div>
            ) : null}
            {/* Eğer type "sound", "video" veya "image" varsa medya içeriklerini göster */}
            {props.question['type'] === "sound" ? (
                <div style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "500px",
                    maxHeight: "300px"
                }}>
                    <ReactAudioPlayer
                        src={props.question['url']}
                        controls={true}
                        controlsList="nodownload"

                    />
                </div>
            ) : null}

            {props.question['type'] === "video" ? (
                <div style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "500px",
                    minHeight: "300px"
                }}>
                    <ReactPlayer
                        className='react-player'
                        url={props.question['url']}
                        controls={true}
                        width="100%"
                        height="300px"
                    />
                </div>
            ) : null}

            {props.question['type'] === "image" ? (
                <div style={{
                    width: "auto",
                    maxWidth: "auto",
                    height: "auto",
                    margin: "0 auto",
                    overflow: "hidden",
                    ...getDynamicPadding()  // Dinamik padding uygula   
                }}>
                    <img
                        src={props.question['url']}
                        alt="Question Media"
                        style={{
                            width: "80%",
                            height: "100%",
                            maxHeight: "250px",
                            objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                        }}
                    />
                </div>
            ) : null}

            {/* Sadece metin varsa, medya öğeleri render edilmez */}
            {/* {props.question['type'] !== "sound" && props.question['type'] !== "video" && props.question['type'] !== "image" ? (
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {props.question['text']}
                </div>
            ) : null} */}
        </div>
    );
};

export default QuestionContents;
